import { render } from "./chevron-down.vue?vue&type=template&id=64f3ba5e"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/chevron-down.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64f3ba5e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64f3ba5e', __exports__)) {
    api.reload('64f3ba5e', __exports__)
  }
  
  module.hot.accept("./chevron-down.vue?vue&type=template&id=64f3ba5e", () => {
    api.rerender('64f3ba5e', render)
  })

}


export default __exports__